import React, { useState } from 'react';
import '../style/CalendarView.css'; // Pastikan file CSS ada di folder style
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

// Komponen menerima 'events' sebagai properti (props) dari AuctionPage
const CalendarView = ({ events }) => {
    const [currentDate, setCurrentDate] = useState(new Date());

    const daysOfWeek = ['Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab', 'Min'];
    const monthNames = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

    // Fungsi untuk pindah ke bulan sebelumnya atau berikutnya
    const changeMonth = (amount) => {
        setCurrentDate(prevDate => {
            const newDate = new Date(prevDate);
            newDate.setMonth(newDate.getMonth() + amount);
            return newDate;
        });
    };

    // Fungsi untuk merender header kalender
    const renderHeader = () => (
        <div className="calendar-header">
            <button onClick={() => changeMonth(-1)} className="nav-button"><FaChevronLeft /></button>
            <h2>{monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}</h2>
            <button onClick={() => changeMonth(1)} className="nav-button"><FaChevronRight /></button>
        </div>
    );

    // Fungsi untuk merender nama-nama hari
    const renderDays = () => (
        <div className="calendar-days-header">{daysOfWeek.map(day => <div key={day}>{day}</div>)}</div>
    );

    // Fungsi utama untuk merender sel-sel tanggal
    const renderCells = () => {
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth();
        const firstDayOfMonth = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        
        // Menyesuaikan agar Senin (1) menjadi awal minggu
        const startDay = (firstDayOfMonth === 0) ? 6 : firstDayOfMonth - 1;
        const cells = [];
        
        // Menambahkan sel kosong di awal bulan
        for (let i = 0; i < startDay; i++) {
            cells.push(<div className="calendar-cell empty" key={`empty-${i}`}></div>);
        }

        // Mengambil data event untuk tahun dan bulan yang sedang ditampilkan
        const yearEvents = events[year] || {};
        const monthEvents = yearEvents[month] || {};

        // Membuat sel untuk setiap tanggal
        for (let day = 1; day <= daysInMonth; day++) {
            const today = new Date();
            const isCurrentDay = day === today.getDate() && month === today.getMonth() && year === today.getFullYear();
            const event = monthEvents[day]; // Mengecek apakah ada event untuk tanggal ini

            cells.push(
                <div className={`calendar-cell ${isCurrentDay ? 'current' : ''} ${event ? 'event' : ''}`} key={day}>
                    <span className="day-number">{day}</span>
                    {event && <div className="event-name">{event}</div>}
                </div>
            );
        }

        return <div className="calendar-grid">{cells}</div>;
    };

    return (
        <div className="calendar-container shadow-sm">
            {renderHeader()}
            {renderDays()}
            {renderCells()}
        </div>
    );
};

export default CalendarView;
